module.exports = __webpack_public_path__ + "img/ic-reflets.73b2b055.svg";